import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider as ReduxProvider } from "react-redux"

import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import store from "./redux/store"

// import i18n (needs to be bundled)
import './i18n'

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
)

// dig a bit more on this later,
// replaced by "root.render(<App />)" to avoid calling events twice.
//root.render(
//  <React.StrictMode>
//    <App />
//  </React.StrictMode>
//)

root.render(
  //<React.StrictMode>
    <ReduxProvider store={store}>
      <App />
    </ReduxProvider>
  //</React.StrictMode>
)

reportWebVitals()
